
	import ModeloCadastro from '@/views/paginas/sigap/modelos/ModeloCadastro.vue';   
    import { Options   } from "vue-class-component";   
    import {  Instrutor } from "./Instrutor"; 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
	import $ from "jquery"   
	  
    @Options({
        name: "InstrutorCadastro",
        components: {   },  
        emits: [  'instrutor-alterado'],  
    }) 
    export default class InstrutorCadastro extends ModeloCadastro {
        
        
        async created()  {  
            this.titulo = 'Cadastrar Instrutor'
            this.campos =  Instrutor.campos();  
            await this.service.getEscolaridades().then(response =>{ 
               this.campos.push(
                    {
                        nome: "escolaridade",
                        type: "select",
                        label: "Escolaridade",
                        sm: 12,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
            await this.service.getTipoPagamento().then(response =>{
               this.campos.push(
                    {
                        nome: "tipoPagamento",
                        type: "select",
                        label: "Tipo Pagamento",
                        sm: 12,
                        lg: 6,
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
            await this.service.getTipo().then(response =>{
               this.campos.push(
                    {
                        nome: "tipo",
                        type: "select",
                        label: "Tipo de Instrutor",
                        sm: 12,
                        lg: 6,
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
            this.formulario.tipo = 1; // PRINCIPAL por padrao
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
   
        public getdados(){   
            let dados = JSON.parse(JSON.stringify(this.formulario));  
            dados.disciplinaId = this.$route.params.id; 
            return dados;
        }
 
        public sucesso(){  
            this.$emit("instrutor-alterado", null);     
            //$("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
        
        
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrar(   dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                    this.formulario.pelotao = null;
                    this.sucesso();  
                    this.processando = false ; 
                    this.editando = false ;
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }  

    } 
